import React, { useState } from "react";
// import BlogEditor from "./BlogEditor";
import axios from "axios";
import ImageUploading from "react-images-uploading";
import { Button, Typography, Paper, Container, Box, Divider } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CreateIcon from "@mui/icons-material/Create";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./NewStory.module.css";
import NewEditor from "./NewEditor";

const NewStory = ({ handleSubmission, accessToken }) => {
  const [title, setTitle] = useState("");
  const [blogData, setBlogData] = useState(null);
  const [blogHtml, setBlogHtml] = useState("");
  // const [done, setDone] = useState("no");
  const [blogImages, setBlogImages] = useState([]);
  const maxNumber = 1;

  const onBlogImagesChange = (imageList) => {
    setBlogImages(imageList);
  };

  function onBlogChange(e) {
    setBlogHtml(e.target.value);
  }

  const showErrorMessage = (text) => {
    toast.error(text, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const handleSaveBlogPost = (data) => {
    setBlogData(data);
  };

  const handleSubmit = async () => {
    if (!title) {
      toast.error("Blog title is required!");
      return;
    }

    if (!blogHtml) {
      toast.error("Blog content is required!");
      return;
    }

    if (blogImages.length > 0) {
      const allowedExtensions = ["jpg", "jpeg", "png"];
      const fileExtension = blogImages[0].file.name
        .split(".")
        .pop()
        .toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        toast.error(
          "Invalid file type. Please upload a .jpg, .jpeg, or .png image."
        );
        return;
      }
    }

    const newStory = { title, description: blogHtml }; // Save blog data
    try {
      // First, create the new blog post
      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/dash/pro-blog/add`,
        newStory,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (
        response.status === 200 &&
        response.data.success &&
        "blog" in response.data &&
        response.data.blog
      ) {
        toast.success("Blog created successfully!", response.data.blog);
        // If blog creation is successful, upload the image
        if (blogImages.length > 0) {
          const formData = new FormData();
          formData.append("image", blogImages[0].file);
          formData.append("blogId", response.data.blog.id);
          // console.log("formData: ", formData);
          const imageResponse = await axios.post(
            `${import.meta.env.VITE_BACKEND_URL}/dash/pro-blog/upload-image`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
              },
            }
          );
          if (imageResponse.status === 200 && imageResponse.data.success) {
            toast.success("Image uploaded successfully!");

            var newStoryData = {
              ...newStory,
              image_url:
                "imageUrl" in imageResponse.data && imageResponse.data.imageUrl
                  ? imageResponse.data.imageUrl
                  : null,
            };
            handleSubmission(newStoryData);
            setTitle("");
            setBlogHtml(null);
            setBlogImages([]);
            // setDone("submitted");

            // alert(
            //   "Programatically navigate to blogs list to show the latest blog!"
            // );
          } else {
            toast.error("Image upload failed. Please try again.");
          }
        }
      } else {
        toast.error("Blog creation failed. Please try again.");
      }
    } catch (error) {
      toast.error(
        "An error occurred while creating the blog. Please try again."
      );
      console.error("Some error occurred while uploading the blog: ", error);
    }
  };

  return (
    <Container maxWidth="lg" className={styles.blogContainer}>
      <Paper elevation={3} className={styles.blogPaper}>
        <Box className={styles.titleHeader}>
          <CreateIcon fontSize="large" className={styles.titleIcon} />
          {/* <Typography variant="h2" component="h2" className={styles.pageTitle}>
            Make a new blog post!
          </Typography> */}
          <h2>Make a new blog post!</h2>
        </Box>
        
        <Divider className={styles.divider} />
        
        <Box className={styles.formContainer}>
          <input
            type="text"
            className={`input-title ${styles.inputTitle}`}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter your blog title here..."
          />
          
          <Box className={styles.imageUploadSection}>
            <Typography variant="h6" className={styles.uploadImageHeader}>
              Featured Image
            </Typography>
            <ImageUploading
              multiple={false}
              value={blogImages}
              onChange={onBlogImagesChange}
              maxNumber={maxNumber}
              dataURLKey="data_url"
            >
              {({ imageList, onImageUpload, onImageRemoveAll }) => (
                <div className={styles.uploadImageWrapper}>
                  {imageList.length > 0 ? (
                    <div className={styles.loadedImageContainer}>
                      <img
                        src={imageList[0]["data_url"]}
                        alt=""
                        className={styles.uploadedImage}
                      />
                      <Button 
                        variant="contained" 
                        color="error" 
                        onClick={onImageRemoveAll}
                        className={styles.removeImageBtn}
                      >
                        Remove Image
                      </Button>
                    </div>
                  ) : (
                    <div onClick={onImageUpload} className={styles.imageUploadBox}>
                      <CloudUploadIcon sx={{ fontSize: 86, color: '#1976d2' }} />
                      <Typography variant="body1" className={styles.uploadImageText}>
                        Drag and drop image here to upload!
                      </Typography>
                      <Typography variant="body2" className={styles.uploadImageOrText}>
                        Or
                      </Typography>
                      <Button variant="contained" className={styles.uploadImageBtn}>
                        Select an image to upload
                      </Button>
                    </div>
                  )}
                </div>
              )}
            </ImageUploading>
          </Box>
          
          <Box className={styles.editorContainer}>
            <Typography variant="h6" className={styles.editorHeader}>
              Blog Content
            </Typography>
            <NewEditor blogHtml={blogHtml} onBlogChange={onBlogChange} />
          </Box>
          
          <Box className={styles.submitContainer}>
            <Button
              onClick={handleSubmit}
              variant="contained"
              size="large"
              color="primary"
              className={styles.submitBtn}
            >
              Publish Blog Post
            </Button>
          </Box>
        </Box>
      </Paper>
      <ToastContainer style={{ width: "50%" }} />
    </Container>
  );
};

export default NewStory;
